import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// --- Critical-path preloading -------------------------------------------
// In a SPA the browser only discovers the hero image + fonts AFTER it has
// downloaded and executed the JS bundle (a slow waterfall). We kick those
// requests off immediately, in parallel with the bundle, so the largest
// content (hero mockup) and the font start downloading right away.
if (typeof document !== 'undefined') {
  const head = document.head;
  const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/7G1ge6MhrnMniAHTMLEuia/mockup_hecho_.png';
  const link = (rel: string, href: string, opts?: {
    as?: string;
    crossOrigin?: boolean;
    fetchPriority?: string;
  }) => {
    const el = document.createElement('link');
    el.rel = rel;
    el.href = href;
    if (opts?.as) el.setAttribute('as', opts.as);
    if (opts?.crossOrigin) el.crossOrigin = 'anonymous';
    if (opts?.fetchPriority) el.setAttribute('fetchpriority', opts.fetchPriority);
    head.appendChild(el);
  };
  // Open connections early.
  link('preconnect', 'https://cdn.magicpatterns.com', {
    crossOrigin: true
  });
  link('dns-prefetch', 'https://cdn.magicpatterns.com');
  link('preconnect', 'https://fonts.googleapis.com');
  link('preconnect', 'https://fonts.gstatic.com', {
    crossOrigin: true
  });
  // Start the hero image (LCP) download immediately, in parallel with the JS.
  link('preload', HERO_IMG, {
    as: 'image',
    fetchPriority: 'high'
  });
}
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-290" />);
}